<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-38" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Create Job Ad</ion-title>
        <ion-buttons slot="end">
            <ion-button class="pill next-pill-button" data-testid="directions-39" @click="goNext()" :disabled="isSubmitDisabled">
                <span>Next</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <AiLoading :isUS="isUS" :isAustralia="isAustralia" :isLoading="isLoading" @stopLoading="generateContentAi" />

            <el-form class="full_page" :model="form" ref="userForm" label-position="top">
                <div class="input_label">Create your job ad by entering the details, or let our AI do the work for you. Our AI can craft a compelling and {{ message.optimised }} job ad based on your provided information, ensuring it attracts the right candidates quickly and effectively.</div>
    
                <div class="describe-need">
                    <el-form-item :error="v$.job_description.$error" :show-message="false" class="no-scroll"
                        :required="true" prop="job_description">
                        <div class="OneLinkNoTx">
                            <QuillEditor v-model:content="form.job_description" contentType="html"
                                @blur="handleEditorkeyup" @editorChange="handleEditorkeyup"
                                @input="handleEditorkeyup" @keyup="handleEditorkeyup" theme="snow"
                                :options="quillConfig"
                                />
                        </div>
                        <!-- <el-input  :rows="10" class="input_textarea" type="textarea" /> -->
                        <el-form-item-error v-if="v$.job_description.$error">{{ v$.job_description.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                    <!-- <div class="character-count">
                        <span class="character-number">5000</span> characters left
                    </div> -->
                    <el-button class="submit mt-4" type="primary" v-if="completedGenerate == false" @click="generateContentAi">
                        Generate Job Ad using {{generateContentAiUsing}}
                    </el-button>
                    <!-- <el-button class="submit mt-4" type="primary" v-else @click="goNext()" :disabled="isSubmitDisabled">
                        Continue
                    </el-button> -->
                </div>
            </el-form>
        </div>

    </div>
</template>


<script>
import {
    reactive, computed, inject, onMounted, ref
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useRouter,
} from 'vue-router'
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { QuillEditor,Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import AiLoading from '@/components/AiLoading/AiLoading.vue';
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import ImageResize from "quill-image-resize-vue";
Quill.register("modules/imageResize", ImageResize);

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        QuillEditor,
        AiLoading
    },
    directives: {

    },
    setup() {
        const $router = useRouter();
        const $store = useStore();
        const setPageClassGlobal = inject(['setPageClassGlobal']);
        const message = inject('messages');
        const jobListingCreatePageData = $store.getters.getJobListingCreatePageData;
        const completedGenerate = ref(false);
        const quillConfig = ref({
        theme: "snow",
        placeholder: "",
        modules: {
            imageResize: {
            displaySize: true,
            },
            toolbar: [
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
                    [{ 'color': [] }],
                    [{ 'align': [] }],
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['link', 'image', 'video'],
            ],
        },
        });
        const form = reactive({
            job_description: jobListingCreatePageData.job_description ? jobListingCreatePageData.job_description : null,
            short_description: jobListingCreatePageData.short_description ? jobListingCreatePageData.short_description : null,
        });
        // Custom validator for job_description
        const jobDescriptionValidator = (value) => {
            return value !== '<p><br></p>';
        };
        const isAustralia = isAustraliaRegion();
        const isUS = isUSRegion();
        const isLoading = ref(false);
        const rules = computed(() => {
            return {
                job_description: {
                    required: helpers.withMessage('Please enter description', required),
                    customValidator: helpers.withMessage('Please enter a valid description', jobDescriptionValidator),
                }
            };
        });
        const v$ = useVuelidate(rules, form);

        const generateContentAiUsing = isAustralia.value ? 'Locumate.ai' : 'HealthShifts.ai';

        const goNext = async () => {
            const result = await v$.value.$validate()

            if (!result) {
                alert('The form has errors')
                return
            } else {
                console.log("🚀 ~ goNext ~ result:", form)
                const plainFormData = {
                    job_description: form.job_description,
                    short_description: form.short_description,
                };
                $store.dispatch("setJobListingCreatePageData", plainFormData);
                $router.push({
                    name: 'job_question_listing',
                });
            }

        };

   
        const validateField = (fieldName) => {
            console.log("🚀 ~ apple:", v$.value[fieldName].$touch())
            v$.value[fieldName].$touch()
            // Check if fieldName is "job_description"

        };

        
       

        const isSubmitDisabled = computed(() => {

            if (form.job_description === null || form.job_description === '<p><br></p>') {
                return true;
            }

            console.log('Job description is not null.');

            console.log('Pending:', v$.value.$pending); // Log pending status for debugging
            console.log('Errors:', v$.value.$error); // Log error status for debugging

            return v$.value.$pending || v$.value.$error;
            // return Object.values(form).some(value => value === null) || v$.value.$pending || v$.value.$error;
        });

        const goBack = () => {
            $router.push({
                name: 'job_create_listing'
            })
        };
        onMounted(() => {
            setPageClassGlobal('job_poster_create_job_description');
        });

        const generateContentAi = () => {
            isLoading.value = true;
            (async () => {
                try {

                    const response = await $store.dispatch("GET_JOB_POSTER_DESC_AI", {
                        params: {
                            description: form.job_description,
                            hideLoading: true,
                        }
                    });
                    console.log("🚀 ~ response ssssssss:", response)
                    form.job_description = response.data.description;
                    form.short_description = response.data.shortDescription;
                    completedGenerate.value = true;
                    isLoading.value = false;

                } catch (error) {
                    console.log(error);
                    isLoading.value = false;
                    completedGenerate.value = false;
                    console.log("error submit!!");
                }
            })();
        }
        
        const handleEditorkeyup = () => {
            cleanUpContent();
            validateField('job_description');
        };

        // Cleanup function to remove empty tags like <p><br></p>
        const cleanUpContent = () => {
            form.job_description = form.job_description
    .replace(/<(h[1-6]|p)><br><\/\1>/g, '')  // Remove <h1><br></h1>, <p><br></p>, etc.
    .replace(/<(h[1-6]|p)>\s*<\/\1>/g, '')  // Remove empty headers <h1> to <h6> and <p>
    .replace(/\n/g, '')  // Remove unnecessary new lines
    .trim() || '';
            // form.job_description = form.job_description.replace(/<h3><br><\/h3>/g, '').trim() || '';
        };

        return {
            goBack,
            goNext,
            form,
            v$,
            validateField,
            isSubmitDisabled,
            generateContentAi,
            isAustralia,
            isUS,
            isLoading,
            completedGenerate,
            quillConfig,
            message,
            generateContentAiUsing,
            handleEditorkeyup
        }
    },
}
</script>
<style>
.ql-tooltip.ql-editing {
  position: fixed !important; /* Fix the position relative to the viewport */
  top: 50% !important;       /* Position it vertically in the center */
  left: 50% !important;      /* Position it horizontally in the center */
  transform: translate(-50%, -50%) !important; /* Center it using transform */
  z-index: 10000 !important; /* Ensure it stays on top of other elements */
}

.ql-tooltip {
  z-index: 10000 !important; /* Ensure the tooltip stays on top */
}
</style>
